/* Rainbow Cammo — PDP behaviors (sticky buy bar reveal). Deferred, vanilla. */
(function () {
  var bar = document.querySelector('[data-rc-buybar]');
  if (!bar) return;

  // Reveal the sticky buy bar once the main Add-to-cart scrolls out of view.
  var anchor = document.querySelector('.product-form__submit');

  function setVisible(visible) {
    bar.classList.toggle('is-visible', visible);
    bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
  }

  if (anchor && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          setVisible(!entry.isIntersecting);
        });
      },
      { rootMargin: '0px 0px -40% 0px' }
    );
    observer.observe(anchor);
  }
})();
